import { Component, NgZone, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';

import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../shared/services/auth.service';

import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {

    private _router: Subscription;

    mediaMatcher: MediaQueryList = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
    today: number = Date.now();
    url: string;
    showSettings = false;
    dark: boolean;
    boxed: boolean;
    collapseSidebar: boolean;
    compactSidebar: boolean;
    currentLang = 'en';
    dir = 'ltr';
    sidePanelOpened;
    user;

    //custom

    regularMenu: any[] = [];
    adminMenu: any[] = [];
    lockInterval;
    lastInteractionTime;

    @ViewChild('sidemenu') sidemenu;
    @ViewChild(PerfectScrollbarDirective) directiveScroll: PerfectScrollbarDirective;

    public config: PerfectScrollbarConfigInterface = {};

    constructor(
        private router: Router,
        public menuItems: MenuItems,
        public translate: TranslateService,
        public zone: NgZone,
        private authService: AuthService) {

            const browserLang: string = translate.getBrowserLang();
            translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
            this.mediaMatcher.addListener(mql => zone.run(() => {
                this.mediaMatcher = mql;
            }));

            this.prepareMenuItems();

            this.initLockManager();
        }


        prepareMenuItems(){ // prepares menu options according to user type
            let isAdmin = this.authService.userIsAdmin();
            let items = this.menuItems.getAll();

            for(let item of items){
                if((item.needAdmin && isAdmin)){
                    this.adminMenu.push(item);
                }else if(!item.needAdmin){
                    this.regularMenu.push(item);
                }
            }
        }

        ngOnInit(): void {

            this.url = this.router.url;

            this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
                document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
                this.url = event.url;
                this.runOnRouteChange();
            });
        }

        ngOnDestroy(): void  {
            this._router.unsubscribe();
        }

        runOnRouteChange(): void {
            if (this.isOver()) {
                this.sidemenu.close();
            }

            this.updatePS();
            this.renewLockManager();
        }

        isOver(): boolean {
            if (this.url === '/apps/messages') {
                return true;
            } else {
                return this.mediaMatcher.matches;
            }
        }

        menuMouseOver(): void {
            if (this.mediaMatcher.matches && this.collapseSidebar) {
                this.sidemenu.mode = 'over';
            }
            this.renewLockManager();
        }

        menuMouseOut(): void {
            if (this.mediaMatcher.matches && this.collapseSidebar) {
                this.sidemenu.mode = 'side';
            }
            this.renewLockManager();
        }

        updatePS(): void  {
            if (!this.mediaMatcher.matches && !this.compactSidebar) {
                setTimeout(() => {
                    this.directiveScroll.update();
                }, 350);
            }
        }

        logout() {
            this.authService.logout();
            this.router.navigate(['/session/signin']);
        }

        //verifies config lock time per user and trigger
        initLockManager(){
            this.lastInteractionTime = new Date().getTime();

            this.lockInterval = setInterval(() => {
                let userConfig = this.authService.getConfig();

                if(userConfig && userConfig.lockout_time && userConfig.lockout_time > 0) {
                    let nowTime = new Date().getTime();
                    let limitTime = this.lastInteractionTime + userConfig.lockout_time * 60 * 1000;

                    if (nowTime > limitTime) {
                        this.lock();
                    }
                }

            }, 10000);

        }
        renewLockManager(){
            this.lastInteractionTime = new Date().getTime();
        }

        lock(){
            clearInterval(this.lockInterval);
            this.authService.lock();
            this.router.navigate(['/session/lockscreen']);
        }


    }



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/layouts/admin/admin-layout.component.ts